module.exports = __webpack_public_path__ + "img/xianwan1.e6a9d234.png";